import wixLocation from 'wix-location'
import wixWindow from 'wix-window'
import { session } from 'wix-storage'
import featuresStaticData from 'public/featuresStaticData'

let currentClickedMenuButton
const isMobile = wixWindow.formFactor === 'Mobile'

$w.onReady(function () {
    if (!isMobile) {
        currentClickedMenuButton = $w('#buttonAll')
    }
    $w('#repeaterFeatures').data = featuresStaticData

    $w('#repeaterFeatures').onItemReady(($item, itemData) => {
        handleItemCategoryUI($item, itemData.category)

        $item('#featureItemHover').hide()
        $item('#featureItemButton').onMouseIn(() => {
            $item('#featureItemHover').show()
            $item('#featureItem').hide()
        })
        $item('#featureItemButton').onMouseOut(() => {
            $item('#featureItem').show()
            $item('#featureItemHover').hide()
        })
        // $item('#textCategory').text = itemData.category.toUpperCase()
        $item('#textTitle').text = itemData.title
        $item('#textDescription').text = itemData.description

        $item('#textTitleHover').text = itemData.title
        $item('#textDescriptionHover').text = itemData.description

        $item('#featureItemButton').onClick(() => {
            wixLocation.to(itemData.link)
        })
    })
    setSearhBehavior()
})

const setSearhBehavior = () => {
    $w('#inputSearchVelo').onKeyPress(event => {
        setTimeout(async () => {
            if (event.key === 'Enter') {
                const searchTerm = $w('#inputSearchVelo').value;
                if (searchTerm) {
                    goToSearchPage(searchTerm);
                }
            }
            if (event.key === 'Escape') {
                $w('#inputSearchVelo').blur();
            }
        }, 50);
    })
}

function handleItemCategoryUI($item, category) {
    const categoryColors = {
        marketing: '#F96132',
        database: '#6C48EF',
        business: '#098961',
        coding: '#170093'
    }
    const categoryColor = categoryColors[category.toLowerCase()]

    $item('#textCategory').html = `<p class='p3' style='color: ${categoryColor}'>${category.toUpperCase()}</p>`;
    if (!isMobile) {
        $item('#textCategoryHover').html = `<p class='p3' style='color: #ffffff'>${category.toUpperCase()}</p>`;
        $item('#featureItemHover').style.backgroundColor = categoryColor
    }
}

const filterFeaturesByCategory = (category) => {
    let data = category ? featuresStaticData.filter(f => f.category === category) : featuresStaticData
    $w('#repeaterFeatures').data = data
}

const setButtonAsClicked = (button) => {
    button.disable()
    currentClickedMenuButton.enable()
    currentClickedMenuButton = button
}

export function buttonAll_click(event) {
    filterFeaturesByCategory()
    setButtonAsClicked(event.target)
}

export function buttonDatabase_click(event) {
    filterFeaturesByCategory('Database')
    setButtonAsClicked(event.target)
}

export function buttonCoding_click(event) {
    filterFeaturesByCategory('Coding')
    setButtonAsClicked(event.target)
}

export function buttonBusiness_click(event) {
    filterFeaturesByCategory('Business')
    setButtonAsClicked(event.target)
}

export function buttonMarketing_click(event) {
    filterFeaturesByCategory('Marketing')
    setButtonAsClicked(event.target)
}

// Search Functionality
// TODO: Change to Query not Session Storage

function goToSearchPage(searchTerm) {
    session.setItem('lastSearchTerm', searchTerm);
    wixLocation.to('/search');
}

export function bottomSearchButton_click(event) {
    goToSearchPage($w('#inputSearchVelo').value)
}

// intended  to clear errors from the monitor
export function menuClick(event) { }
export function page1_mouseIn(event) { }
export function inputSearchCorvid_keyPress(event) { }